// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";

// const CheckAuth = ({ isAuthenticated, user, children, isLoading }) => {
//   const location = useLocation();

//   if (
//     !isAuthenticated &&
//     !(
//       location.pathname.includes("/login") ||
//       location.pathname.includes("/register")
//     )
//   ) {
//     return <Navigate to="/auth/login" />;
//   }

//   if (
//     isAuthenticated &&
//     (location.pathname.includes("/login") ||
//       location.pathname.includes("/register"))
//   ) {
//     if (user?.role === "Employee") {
//       return <Navigate to="/admin/dashboard" />;
//     } else if (user?.role === "Superadmin") {
//       return <Navigate to="/superAdmin/super-dashboard" />;
//     }
//   }

//   if (isAuthenticated) {
//     if (
//       user?.role !== "Superadmin" &&
//       location.pathname.includes("/superAdmin")
//     ) {
//       return <Navigate to="/unauth-page" />;
//     }
//     if (user?.role !== "Employee" && location.pathname.includes("/admin")) {
//       return <Navigate to="/unauth-page" />;
//     }
//   }

//   return <>{children}</>;
// };

// export default CheckAuth;

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const CheckAuth = ({ isAuthenticated, user, children }) => {
  const location = useLocation();
  const normalizedRole = String(user?.role || "").trim().toLowerCase();
  const isSuperadmin = normalizedRole === "superadmin";
  const isEmployee = normalizedRole === "employee";
  const isCorporate = normalizedRole === "corporate";
  const isRequestor = normalizedRole === "requestor";
  const isAccounting = isSuperadmin || String(user?.department || "").trim().toLowerCase() === "accounting";
  const isPathMatch = (basePath) =>
    location.pathname === basePath || location.pathname.startsWith(`${basePath}/`);

  // not authenticated and not in login or register, return to login
  if (
    !isAuthenticated &&
    !(
      isPathMatch("/auth/login") ||
      isPathMatch("/auth/register")
    )
  ) {
    return <Navigate to="/auth/login" replace />;
  }

  // authenticated and in login or register, redirect based on role
  if (
    isAuthenticated &&
    (isPathMatch("/auth/login") ||
      isPathMatch("/auth/register"))
  ) {
    if (isEmployee) {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (isSuperadmin) {
      return <Navigate to="/superAdmin/super-dashboard" replace />;
    }
    else if (isCorporate) {
      return <Navigate to="/corporate/corporate-dashboard" replace />;
    } else if (isRequestor) {
      return <Navigate to="/requestor/dashboard" replace />;
    }
  }

  // Role-based access control
  if (isAuthenticated && user) {
    if (
      !isSuperadmin &&
      isPathMatch("/superAdmin")
    ) {
      return <Navigate to="/unauth-page" replace />;
    }
    if (!isEmployee && isPathMatch("/admin")) {
      return <Navigate to="/unauth-page" replace />;
    }
    if (!isCorporate && isPathMatch("/corporate")) {
      return <Navigate to="/unauth-page" replace />;
    }
    if (!isRequestor && isPathMatch("/requestor")) {
      return <Navigate to="/unauth-page" replace />;
    }
    // Accounting: allow Superadmin or anyone from Accounting department
    if (
      isPathMatch("/accounting") &&
      !isAccounting
    ) {
      return <Navigate to="/unauth-page" replace />;
    }
  }

  return <>{children}</>;
};

export default CheckAuth;
